import isEmpty from 'is-empty';
import {
  MT_LIP_INVESTMENT,
  MT_LIP_INVESTMENT_ERROR,
  MT_LIP_INVESTMENT_LOADING,
  MT_LIP_INVESTMENT_ERROR_DELETE
} from '../../../actions/types';

const initialState = {
  success: false,
  mtLipInvestment: {},
  error: '',
  loading: false
};

const mtLipInvestment = (state = initialState, action) => {
  switch (action.type) {
    case MT_LIP_INVESTMENT:
      return {
        ...state,
        success: !isEmpty(action.mtLip),
        mtLipInvestment: action.mtLip,
        loading: false
      };
    case MT_LIP_INVESTMENT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case MT_LIP_INVESTMENT_ERROR_DELETE:
      return {
        error: ''
      };
    case MT_LIP_INVESTMENT_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default mtLipInvestment;
